module.exports = __webpack_public_path__ + "static/media/MTL_SL_BOSS1.13a19647.png";